module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedLight.625fc4d.ttf";